import { TaskStatus } from "src/constants/commonEnums";

export const getTaskCountByStatus = (taskExecutions) => {
    const status = {};
    Object.keys(TaskStatus).forEach(
        (val) =>
        (status[val] = taskExecutions.filter(
            (task) => task.status === val
        ).length)
    );
    return status;
}
